import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import LogoConecta from "../assets/images/Fundemas_Logo3.png"
import LogoAlianzas from "../assets/images/imagenAlianzas.png"
import LogoEducacion from "../assets/images/imagenEducacion.png"

// Configurar el elemento root para accesibilidad
Modal.setAppElement("#root");

export default function ModalInicio() {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const closeModal = () => {
        setModalIsOpen(false); // Cerrar el modal
        localStorage.setItem("modalClosed", "true"); // Almacenar en localStorage que el modal fue cerrado
    };

    useEffect(() => {
        // Verificar si el modal ya fue cerrado previamente
        const modalClosed = localStorage.getItem("modalClosed");
        if (!modalClosed) {
            setModalIsOpen(true); // Mostrar el modal solo si no se ha cerrado antes
        }
    }, []);

    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Informacion"
                className="bg-[#0D7F9F] rounded-2xl shadow-lg w-full md:w-3/4 mx-auto outline-none max-w-3xl"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start md:items-center justify-center overflow-y-auto z-50 p-4"
            >
                <div className="rounded-2xl outline-none">
                    <div className="flex justify-between rounded-t-xl w-full bg-white items-center">
                        <img src={LogoConecta} className="h-10 2xl:h-12 m-3" alt="" />
                        <button
                            id="closeModal"
                            className="m-3 text-white p-4 rounded-full bg-[#E3087F] flex items-center justify-center w-[30px] 2xl:w-[50px] h-[30px] 2xl:h-[50px] transition-colors hover:bg-[#ba0467]"
                            onClick={closeModal}
                        >
                            <FontAwesomeIcon icon={faXmark} className="text-lg 2xl:text-2xl" />
                        </button>
                    </div>
                    <p className="text-white text-xl text-start px-5 py-2 2xl:pt-6 2xl:pb-3">
                        A través de esta herramienta <span className="text-[#FFCA15] font-bold">FUNDEMAS</span> contribuye al impacto de los siguientes Objetivos de Desarrollo Sostenible (ODS).
                    </p>
                    <div className="flex flex-col md:flex-col mx-6 my-2 p-4 rounded-xl bg-white gap-4">
                        <div>
                            <h2 className="text-xl font-bold">ODS 4.</h2>
                            <p className="text-base 2xl:text-lg">Educación de Calidad.</p>
                        </div>

                        <div className="w-full flex flex-col md:flex-row items-center gap-4">
                            <div className="w-full md:w-1/3 lg:w-1/5 flex justify-center items-center h-full">
                                <img alt="" src={LogoEducacion} className="h-28 md:max-h-28 my-2" />
                            </div>
                            <div className="p-2 w-full md:w-2/3 lg:w-4/5">
                                <h2 className="text-xl font-bold text-[#0D7F9F] pb-2">Específicamente:</h2>
                                <p className="text-base">
                                    <span className="font-bold">4.2</span> De aquí a 2030, asegurar que todas las niñas y todos los niños tengan acceso a servicios de atención y desarrollo en la primera infancia y educación preescolar de calidad, a fin de que estén preparados para la enseñanza primaria.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-col mx-6 my-2 p-4 rounded-xl bg-white gap-4 mb-5">
                        <div>
                            <h2 className="text-xl font-bold">ODS 5.</h2>
                            <p className="text-base 2xl:text-lg">Alianzas para lograr objetivos.</p>
                        </div>
                        <div className="w-full flex flex-col md:flex-row items-center gap-4">
                            <div className="w-full md:w-1/3 lg:w-1/5 flex justify-center items-center h-full">
                                <img alt="" src={LogoAlianzas} className="h-28 md:max-h-28 my-2" />
                            </div>
                            <div className="p-2 w-full md:w-2/3 lg:w-4/5">
                                <h2 className="text-xl font-bold text-[#0D7F9F] pb-2">
                                    Específicamente:
                                </h2>
                                <p className="text-base">
                                    <span className="font-bold">17.9</span> Aumentar el apoyo internacional para realizar actividades de creación de capacidad eficaces y específicas en los países en desarrollo a fin de respaldar los planes nacionales de implementación de todos los Objetivos de Desarrollo Sostenible, incluso mediante la cooperación Norte-Sur, Sur-Sur y triangular.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}